
interface Metric {
  value: string;
  label: string;
}

const MetricsSection = () => {
  const metrics: Metric[] = [
    {
      value: "99.7%",
      label: "Threat Detection Accuracy"
    },
    {
      value: "82.0%",
      label: "Reduction in MTTR"
    },
    {
      value: "95.0%",
      label: "Alert Reduction"
    },
    {
      value: "3.0X",
      label: "Analyst Efficiency"
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            <span className="text-spharaka-purple">Spharaka Autonomous Cyber Defence Platform</span> By The Numbers
          </h2>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {metrics.map((metric, index) => (
            <div 
              key={index} 
              className="text-center"
            >
              <div className="text-5xl md:text-6xl font-bold text-spharaka-purple mb-2">
                {metric.value}
              </div>
              <div className="text-lg text-gray-600">
                {metric.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MetricsSection;
